import { render } from "./OriginBadge.vue?vue&type=template&id=5172e9ee&scoped=true&ts=true"
import script from "./OriginBadge.vue?vue&type=script&lang=ts"
export * from "./OriginBadge.vue?vue&type=script&lang=ts"

import "./OriginBadge.vue?vue&type=style&index=0&id=5172e9ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5172e9ee"]])

export default __exports__